import React from 'react';

const EditIcon = () => {
  return (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.5 17.225H3.75C3.58424 17.225 3.42527 17.1592 3.30806 17.0419C3.19085 16.9247 3.125 16.7658 3.125 16.6V13.1089C3.125 13.0268 3.14117 12.9455 3.17258 12.8697C3.20398 12.7939 3.25002 12.725 3.30806 12.6669L12.6831 3.29194C12.8003 3.17473 12.9592 3.10889 13.125 3.10889C13.2908 3.10889 13.4497 3.17473 13.5669 3.29194L17.0581 6.78306C17.1753 6.90027 17.2411 7.05924 17.2411 7.225C17.2411 7.39076 17.1753 7.54973 17.0581 7.66694L7.5 17.225Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.625 5.3501L15 9.7251"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.8753 17.2249H7.50027L3.16504 12.8896"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default EditIcon;
